import React from "react";
import AuthLayout from "../../Components/Layouts/AuthLayout";

const Onboarding = () => {
  return <AuthLayout>Onboarding</AuthLayout>;
};

export default Onboarding;
